var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-body',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }